import { render, staticRenderFns } from "./Substitutes.vue?vue&type=template&id=2c923bec&scoped=true&"
import script from "./Substitutes.vue?vue&type=script&lang=ts&"
export * from "./Substitutes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c923bec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c923bec')) {
      api.createRecord('2c923bec', component.options)
    } else {
      api.reload('2c923bec', component.options)
    }
    module.hot.accept("./Substitutes.vue?vue&type=template&id=2c923bec&scoped=true&", function () {
      api.rerender('2c923bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/substitutes/Substitutes.vue"
export default component.exports